import { render, staticRenderFns } from "./AssetMultiUpload.vue?vue&type=template&id=2d52dfe7&scoped=true&"
import script from "./AssetMultiUpload.vue?vue&type=script&lang=js&"
export * from "./AssetMultiUpload.vue?vue&type=script&lang=js&"
import style0 from "./AssetMultiUpload.vue?vue&type=style&index=0&id=2d52dfe7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d52dfe7",
  null
  
)

export default component.exports